module.exports = require("prop-types");


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"prop-types","commonjs2":"prop-types","amd":"prop-types","root":"PropTypes"}
// module id = 18
// module chunks = 0